import { PenIconComponent } from 'assets/icons';
import styles from './EditUserInfo.module.scss';
import useTranslation from 'hooks/useTranslation';
import { useModal } from 'hooks';
import { UserInfoModal } from 'components';

function EditUserInfo() {
  const { getTranslation } = useTranslation([
    'PACKAGE_UPGRADING',
    'BILLS_LIST',
  ]);
  const { t } = getTranslation();
  const [visible, toggle] = useModal();

  return (
    <>
      <div
        className='flex flex-ai-c flex-colgap-4 cursor-pointer'
        onClick={toggle}
      >
        <PenIconComponent />
        <span className={styles.edit}>{t('INFO_EDIT_BTN')}</span>
      </div>
      <UserInfoModal visible={visible} handleClose={toggle} />
    </>
  );
}

export default EditUserInfo;
